module.exports = global["$"] = require("-!/home/ubuntu/thriveministry-hub/node_modules/expose-loader/index.js?jQuery!./jquery.js");